import { gsap } from '../global/gsap';

const initFadeImages = (els) => {
    els.forEach(el => {
        const tl = gsap.timeline({
            scrollTrigger : {
                trigger: el.parentNode,
                start: 'top 70%'
            },
            defaults: {
                ease: 'power3.inOut',
                duration: .75
            }
        })

        gsap.set(el, { autoAlpha: 0 });

        tl.to(el, { autoAlpha: 1, stagger: .05});
    })
}   

export default initFadeImages;